import { Select } from 'antd'
import { useMemo } from 'react'
import { useScheduleContext } from '../Contexts/ScheduleContext'

export function ScheduleOrderFilter() {
  const { selectedOrders, setSelectedOrders, schedules } = useScheduleContext()

  const orderOptions = useMemo(() => {
    const allOrderNumbers =
      (schedules as Array<{ trips?: Array<{ number: number }> }> | undefined)?.flatMap(
        (x) => x.trips?.map((t) => t.number) ?? []
      ) ?? []
    return [...new Set(allOrderNumbers)].filter((x) => x !== -1).map((x) => ({ label: x.toString(), value: x }))
  }, [schedules])

  return (
    <Select
      mode='multiple'
      allowClear
      style={{ overflowY: 'auto', width: '30%' }}
      placeholder='Search Assigned Orders'
      onChange={setSelectedOrders}
      options={orderOptions}
      value={selectedOrders}
      size='small'
    />
  )
}
